import { getToken } from '@devd-client/api';

const CHAT_API_BASE = process.env['NX_CHAT_API_HOST'];

export interface Session {
  id: string;
  title: string;
  created_at: string;
  updated_at: string;
}

// Get all chat sessions
export const getSessions = async (): Promise<Session[]> => {
  const response = await fetch(`${CHAT_API_BASE}/sessions`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `bearer ${getToken()}`,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch sessions');
  }

  const data = await response.json();
  return data.sessions || data || [];
};

// Create a new chat session
export const createSession = async (title = 'New Chat'): Promise<Session> => {
  const response = await fetch(`${CHAT_API_BASE}/sessions`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({ title }),
  });

  if (!response.ok) {
    throw new Error('Failed to create session');
  }

  return response.json();
};

// Update a chat session (e.g., rename)
export const updateSession = async (
  sessionId: string,
  title: string
): Promise<Session> => {
  const response = await fetch(`${CHAT_API_BASE}/sessions/${sessionId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({ title }),
  });

  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Session not found');
    }
    throw new Error('Failed to update session');
  }

  return response.json();
};

// Delete (archive) a chat session
export const deleteSession = async (sessionId: string): Promise<void> => {
  const response = await fetch(`${CHAT_API_BASE}/sessions/${sessionId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `bearer ${getToken()}`,
    },
  });

  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Session not found');
    }
    throw new Error('Failed to delete session');
  }
};
